import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./Dashboard.css";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import App from "./App";
import { store } from "./app/store";
import { Provider } from "react-redux";
import { ThemeProvider } from "./utils/ThemeContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </Provider>
);

// Change unregister() to register()
serviceWorkerRegistration.register();